import netsAnsweringRuleDetails from './nets-answering-rule-details';
import moduleConfig from './module-config';

export default angular
  .module('app.answerRules', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsAnsweringRuleDetails', netsAnsweringRuleDetails);
